export const FEATURE_FLAGS = {
  WARRANTIES: 'warranties',
};
